class IndicativeNumberDTO {

    constructor(id, number) {
        this.id = id;
        this.number = number;
    }

}

export default IndicativeNumberDTO